module.exports = __webpack_public_path__ + "img/whappy-loading.afef3f35.gif";